var _path, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgIncoming = function SvgIncoming(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.5H8.93365L8.99497 12.0707C9.47851 8.68596 10.9216 6.29546 12.8293 4.62629C14.1897 3.43591 15.7997 2.60118 17.4928 2.04239C15.0316 4.51457 13.9 7.75712 13.9 12V12.5H14.4H17.2929L11.5 18.2929L5.70711 12.5H8.5Z",
    stroke: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 20,
    width: 19,
    height: 2,
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 18,
    width: 2,
    height: 4,
    fill: "currentColor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 18,
    width: 2,
    height: 4,
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIncoming);
export { ForwardRef as ReactComponent };